import { useCallback, useState } from "react"

import { useApiObservableHandler } from "./useApiObservableHandler"
import printPdf from "../../utils/printPdf"
import AuthFormProcessObservable from "../OrderResults/AuthForm"

interface PrintAuthFormProps {
  formFoxTestAN: number
  personId: number
  vendorId: number
  callback?: (response?: string) => void
}

function useAuthFormProcessPrint() {
  const [processing, setProcessing] = useState(false)
  const [response, setResponse] = useState("")

  const handleApi = useApiObservableHandler<string>()

  const printAuthForm = useCallback(
    ({ formFoxTestAN, personId, vendorId }: PrintAuthFormProps) => {
      return handleApi({
        observableFactory: () =>
          AuthFormProcessObservable({
            EmailAddress: [],
            FormFoxTestAN: formFoxTestAN,
            PersonID: personId,
            VendorID: vendorId,
            SendToEmail: false,
            SendText: false,
          }),
        onSuccess: printPdf,
        onLoadingChange: setProcessing,
        setResponse,
      })
    },
    [handleApi, setProcessing, setResponse]
  )

  return {
    processing,
    response,
    printAuthForm,
  }
}

export default useAuthFormProcessPrint
